// extracted by mini-css-extract-plugin
export var about = "about-module--about--8c7a7";
export var btn = "about-module--btn--802b4";
export var description = "about-module--description--2eca3";
export var heading = "about-module--heading--5d6ca";
export var mobileViewBtn = "about-module--mobileViewBtn--db5b2";
export var teamGrid = "about-module--teamGrid--d6dd5";
export var teamMember = "about-module--teamMember--b46a3";
export var teamMemberImg = "about-module--teamMemberImg--af418";
export var teamSection = "about-module--teamSection--86077";
export var textBox = "about-module--textBox--83945";
export var whoWeAreImg = "about-module--whoWeAreImg--170cf";